module.exports = {
  get withAuth() {
    return require('./withAuth').default;
  },

  get withoutAuth() {
    return require('./withoutAuth').default;
  },

  get withDropzone() {
    return require('./withDropzone').default;
  },

  get withLoader() {
    return require('./withLoader').default;
  },

  get withSearch() {
    return require('./withSearch').default;
  },

  get withSearchLocation() {
    return require('./withSearchLocation').default;
  },

  get withPreview() {
    return require('./withPreview').default;
  },
};